import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Text } from 'native-base';
import React from 'react';

import { CardHeader } from '../CardHeader';

export interface DetailsItemProps {
  label: string;
  value: string | React.ReactNode;
}

export interface TicketApplicationBaseInfoProps {
  orderHash: string;
  productDetails?: DetailsItemProps[];
  orderDetails?: DetailsItemProps[];
  isSimplifiedApplication?: boolean;
}

export interface TicketApplicationSuccessDetailsProps extends TicketApplicationBaseInfoProps {
  onClose: () => void;
  onFollow: () => void;
  onExportPdf?: () => void;
  closeButtonText?: string;
  followButtonText?: string;
}
export const TicketApplicationSuccessDetails: React.FC<TicketApplicationSuccessDetailsProps> = ({
  orderHash,
  productDetails,
  orderDetails,
  onClose,
  closeButtonText = 'Nova boleta',
  onExportPdf,
  onFollow,
  followButtonText = 'Acompanhar',
}) => {
  const renderInfo = (info: DetailsItemProps) => {
    const isValueString = typeof info.value === 'string';

    return (
      <HStack justifyContent="space-between" space={Spacing['inline.quarck']}>
        <UI.Text>{info.label}</UI.Text>
        {isValueString ? (
          <UI.Text maxW={{ base: '200px', sm: '2/3' }} variant="semibold" textAlign="right">
            {info.value}
          </UI.Text>
        ) : (
          info.value
        )}
      </HStack>
    );
  };

  return (
    <VStack space={Spacing['stack.xxxs']}>
      <CardHeader onClose={onClose} handleExportPdf={onExportPdf} />
      <UI.Shadow level={1} borderRadius={BoxBorder.heavy}>
        <VStack p={Spacing['inset.sm']} space={Spacing['stack.xxxs']}>
          <HStack
            borderRadius={BoxBorder.heavy}
            p={Spacing['inset.nano']}
            space={Spacing['inline.quarck']}
            bg={Utils.ColorToken.WithOpacity('neutral.lightest', 0.15)}
            alignItems="center">
            <UI.Icon name="Check" size="md" color={Color['feedback.success.default']} />
            <VStack maxW="90%">
              <UI.Text variant="semibold">
                Ordem {orderHash !== '' ? `#${orderHash}` : ''} enviada com sucesso{' '}
              </UI.Text>
              <UI.Text noOfLines={2}>
                Você poderá acompanhar suas ordens clicando no botão{' '}
                <Text fontWeight="semibold">acompanhar.</Text>
              </UI.Text>
            </VStack>
          </HStack>

          {productDetails && (
            <VStack
              borderRadius={BoxBorder.heavy}
              px={Spacing['inline.xxs']}
              py={Spacing['stack.xxxs']}
              space={Spacing['stack.nano']}
              bg={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.3)}>
              <UI.Text variant="semibold">Detalhes do produto</UI.Text>
              {productDetails.map((item) => (
                <Stack key={item.label} w="full">
                  {renderInfo(item)}
                </Stack>
              ))}
            </VStack>
          )}

          {orderDetails && (
            <VStack
              borderRadius={BoxBorder.heavy}
              px={Spacing['inline.xxs']}
              py={Spacing['stack.xxxs']}
              space={Spacing['stack.nano']}
              bg={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.3)}>
              <UI.Text variant="semibold">Detalhes da ordem</UI.Text>
              {orderDetails.map((item) => (
                <Stack key={item.label} w="full">
                  {renderInfo(item)}
                </Stack>
              ))}
            </VStack>
          )}
        </VStack>
      </UI.Shadow>

      <Stack
        direction={Utils.Responsive.TabletDesktop({ tablet: 'column', desktop: 'row' })}
        justifyContent="space-between"
        space={Spacing['inline.xxxs']}>
        <UI.Button flex={1} variant="secondary" onPress={onFollow}>
          {followButtonText}
        </UI.Button>
        <UI.Button flex={1} variant="primary" onPress={onClose}>
          {closeButtonText}
        </UI.Button>
      </Stack>
    </VStack>
  );
};
